import { makeStyles } from '@material-ui/core'
import React, { useState } from 'react'
import Father from 'src/assets/Buy_Policy_Images/Father.svg'
import Mother from 'src/assets/Buy_Policy_Images/Mother.svg'
import { MenuItem, Select } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import { Clear } from '@mui/icons-material'
import { addScroll, removeScroll } from 'src/utils/commonMethods'

const ParentsAndInLawsAgeForm = ({
  ageDetails,
  onParentsAgeChange,
  minAge,
}) => {
  const classes = useStyles()
  const [parentsAgeDetails, setParentsAgeDetails] = useState(ageDetails)

  // Generate an array of numbers from 1 to 100 and filter number greater than 18
  const numbers = Array.from({ length: 100 }, (_, index) => index + 1)
  const ageInYears = numbers?.filter((number) => number >= minAge)

  const handleParentAgeChange = (event) => {
    const parentsAge = parentsAgeDetails
    parentsAge[event.target.name] = Number(event?.target?.value)
    setParentsAgeDetails(JSON.parse(JSON.stringify(parentsAge)))
    onParentsAgeChange(JSON.parse(JSON.stringify(parentsAge)))
  }

  const handleClear = (key) => {
    const parentsAge = parentsAgeDetails
    parentsAge[key] = ''
    setParentsAgeDetails(JSON.parse(JSON.stringify(parentsAge)))
    onParentsAgeChange(JSON.parse(JSON.stringify(parentsAge)))
  }

  return (
    <>
      <div>
        <div className={classes.parentsContainer}>
          <div className={classes.parentsHeadingContent}>
            <span className={classes.parentsHeading}>Select Parents Age</span>
            <span className={classes.parentsHeading}>Select In-laws Age</span>
          </div>
          <div className={classes.parentsContent}>
            <div className={classes.parentsImageContent}>
              <img src={Father} alt='father' className={classes.parentsImage} />
            </div>
            <div className={classes.parentsContentInput}>
              <Select
                placeholder='Select Age'
                id='fatherAge'
                name='fatherAge'
                value={parentsAgeDetails.fatherAge ?? ''}
                onChange={handleParentAgeChange}
                className={`${'form-input'} ${classes.parentsFormInput}`}
                displayEmpty
                sx={{
                  '&  .MuiInputBase-root': {
                    height: '0.7rem !important',
                    minHeight: 'unset',
                    width: '100px',
                  },
                  '&  .MuiSelect-select': {
                    minHeight: 'unset',
                    width: '100px',
                  },
                  '& .MuiSelect-iconOutlined': {
                    display: parentsAgeDetails?.fatherAge ? 'none' : '',
                  },
                }}
                endAdornment={
                  <IconButton
                    id='fatherAgeClear'
                    sx={{ display: parentsAgeDetails?.fatherAge ? '' : 'none' }}
                    onClick={() => handleClear('fatherAge')}
                  >
                    <Clear className={classes.clearIcon} />
                  </IconButton>
                }
                onOpen={() => {
                  removeScroll()
                }}
                onClose={() => {
                  addScroll()
                }}
              >
                <MenuItem value=''>Select Age</MenuItem>
                {ageInYears?.map((number) => (
                  <MenuItem key={number} value={number}>
                    {number}
                  </MenuItem>
                ))}
              </Select>
            </div>
            <div className={classes.parentsContentInput}>
              <Select
                placeholder='Select Age'
                id='fatherInLawAge'
                name='fatherInLawAge'
                value={parentsAgeDetails?.fatherInLawAge ?? ''}
                onChange={(event) => handleParentAgeChange(event)}
                className={`${'form-input'} ${classes.parentsFormInput}`}
                displayEmpty
                sx={{
                  '&  .MuiInputBase-root': {
                    height: '0.7rem !important',
                    minHeight: 'unset',
                    width: '100px',
                  },
                  '&  .MuiSelect-select': {
                    minHeight: 'unset',
                    width: '100px',
                  },
                  '& .MuiSelect-iconOutlined': {
                    display: parentsAgeDetails?.fatherInLawAge ? 'none' : '',
                  },
                }}
                endAdornment={
                  <IconButton
                    id='fatherInLawAgeClear'
                    sx={{
                      display: parentsAgeDetails?.fatherInLawAge ? '' : 'none',
                    }}
                    className={'clear-button'}
                    onClick={() => handleClear('fatherInLawAge')}
                  >
                    <Clear />
                  </IconButton>
                }
                onOpen={() => {
                  removeScroll()
                }}
                onClose={() => {
                  addScroll()
                }}
              >
                <MenuItem value=''>Select Age</MenuItem>
                {ageInYears?.map((number) => (
                  <MenuItem key={number} value={number}>
                    {number}
                  </MenuItem>
                ))}
              </Select>
            </div>
          </div>
          <div className={classes.parentsContent}>
            <div className={classes.parentsImageContent}>
              <img src={Mother} alt='mother' className={classes.parentsImage} />
            </div>
            <div className={classes.parentsContentInput}>
              <Select
                placeholder='Select Age'
                id='motherAge'
                name='motherAge'
                value={parentsAgeDetails.motherAge ?? ''}
                onChange={handleParentAgeChange}
                className={`${'form-input'} ${classes.parentsFormInput}`}
                displayEmpty
                sx={{
                  '&  .MuiInputBase-root': {
                    height: '0.7rem !important',
                    minHeight: 'unset',
                    width: '100px',
                  },
                  '&  .MuiSelect-select': {
                    minHeight: 'unset',
                    width: '100px',
                  },
                  '& .MuiSelect-iconOutlined': {
                    display: parentsAgeDetails?.motherAge ? 'none' : '',
                  },
                }}
                endAdornment={
                  <IconButton
                    id='motherAgeClear'
                    sx={{ display: parentsAgeDetails?.motherAge ? '' : 'none' }}
                    className={'clear-button'}
                    onClick={() => handleClear('motherAge')}
                  >
                    <Clear />
                  </IconButton>
                }
                onOpen={() => {
                  removeScroll()
                }}
                onClose={() => {
                  addScroll()
                }}
              >
                <MenuItem value=''>Select Age</MenuItem>
                {ageInYears?.map((number) => (
                  <MenuItem key={number} value={number}>
                    {number}
                  </MenuItem>
                ))}
              </Select>
            </div>
            <div className={classes.parentsContentInput}>
              <Select
                placeholder='Select Age'
                id='motherInLawAge'
                name='motherInLawAge'
                value={parentsAgeDetails.motherInLawAge ?? ''}
                onChange={handleParentAgeChange}
                className={`${'form-input'} ${classes.parentsFormInput}`}
                displayEmpty
                sx={{
                  '&  .MuiInputBase-root': {
                    height: '0.7rem !important',
                    minHeight: 'unset',
                    width: '100px',
                  },
                  '&  .MuiSelect-select': {
                    minHeight: 'unset',
                    width: '100px',
                  },
                  '& .MuiSelect-iconOutlined': {
                    display: parentsAgeDetails?.motherInLawAge ? 'none' : '',
                  },
                }}
                endAdornment={
                  <IconButton
                    id='motherInLawAgeClear'
                    sx={{
                      display: parentsAgeDetails?.motherInLawAge ? '' : 'none',
                    }}
                    className={'clear-button'}
                    onClick={() => handleClear('motherInLawAge')}
                  >
                    <Clear />
                  </IconButton>
                }
                onOpen={() => {
                  removeScroll()
                }}
                onClose={() => {
                  addScroll()
                }}
              >
                <MenuItem value=''>Select Age</MenuItem>
                {ageInYears?.map((number) => (
                  <MenuItem key={number} value={number}>
                    {number}
                  </MenuItem>
                ))}
              </Select>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ParentsAndInLawsAgeForm
const useStyles = makeStyles({
  parentsContainer: {
    padding: '20px',
    minWidth: '270px',
  },
  parentsHeadingContent: {
    display: 'flex',
    padding: '0',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: '10%',
  },
  parentsHeading: {
    fontSize: '11px',
    width: '100%',
  },
  parentsContent: {
    display: 'flex',
    padding: '10px 0px 10px 0px',
    width: '100%',
  },
  parentsFormInput: {
    width: '95%',
    height: '30px',
  },
  parentsImage: {
    width: '25px',
  },
  parentsImageContent: {
    width: '10%',
  },
  parentsContentInput: {
    width: '45%',
  },
  clearIcon: {
    width: '0.3em',
    height: '0.3em',
  },
})
